module.exports = __webpack_public_path__ + "img/Is_there_an_easy.3a9a7b2f.png";